const settings = {
  socketServer: {
    url: process.env.REACT_APP_API_URL || 'http://localhost:3001/game'
    // 'https://api.staging.cityinvaders.game/game'
  }
}
export default settings
